var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.57792 18.1C7.22343 18.6601 8.07134 19 9 19C9.92866 19 10.7766 18.6601 11.4221 18.1M14.4926 6.4C14.4926 4.96783 13.9139 3.59432 12.8839 2.58162C11.8538 1.56893 10.4567 1 9 1C7.54327 1 6.14621 1.56893 5.11615 2.58162C4.08608 3.59432 3.5074 4.96783 3.5074 6.4C3.5074 9.18117 2.79379 11.0854 1.99663 12.3449C1.32421 13.4073 0.987999 13.9385 1.00033 14.0867C1.01398 14.2508 1.04933 14.3133 1.18383 14.4114C1.30529 14.5 1.85284 14.5 2.94794 14.5H15.0521C16.1472 14.5 16.6947 14.5 16.8162 14.4114C16.9507 14.3133 16.986 14.2508 16.9997 14.0867C17.012 13.9385 16.6758 13.4073 16.0034 12.3449C15.2062 11.0854 14.4926 9.18117 14.4926 6.4Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.9341f0627526c8b403c862f905b3b6a1.svg";
export { ForwardRef as ReactComponent };